import container from './CQRS';

const { queriesController, commandsController } = container;

async function getModules(childId) {
  try {
    return await queriesController.fetchModules({ childId });
  } catch (error) {
    throw new Error('[Service]: Oops!, we were unable to obtain the modules...');
  }
}

async function getModuleSkills() {
  try {
    return await queriesController.fetchModuleSkills();
  } catch (error) {
    throw new Error('[service]: Oops!, we were unable to obtain the skills');
  }
}

async function setModulesToActivate({ childId = '', modules = [], modulesSelected = [] }) {
  try {
    const modulesMapped = modules.map(({module, module_order}) => ({
      module,
      unlocked: modulesSelected.includes(module_order),
    }));
    return await commandsController.activateModules({ childId, modules: modulesMapped });
  } catch (error) {
    throw new Error();
  }
}

async function getSkillLessonsById({ id }) {
  try {
    return await queriesController.fecthSkillLessons({ id });
  } catch (error) {
    throw new Error('[service]: Oops!, we were unable to obtain the lesson by the skill');
  }
}

async function getLessonDetail(lessonId) {
  try {
    const data = await queriesController.fecthLessonDetail(lessonId);
    const { viewed, date, helpful, watched_video, watched_video_date } = data;
    return { viewed, date, helpful, watched_video, watched_video_date };
  } catch (error) {
    throw new Error('[Service]: Oops!, we were unable to obtain the lesson detail...');
  }
}

async function setInfoIsHelpfull({ helpful, lessonId }) {
  try {
    return commandsController.infoIsHelpfull({ helpful, lessonId });
  } catch (error) {
    console.error(error);
    throw new Error('[Service]: Oops!, We had a problem updating the information...');
  }
}

async function markVideoisViewed(lessonId) {
  try {
    return commandsController.markvideoAsViewed(lessonId);
  } catch (error) {
    console.error(error);
    throw new Error('[Service]: Oops!, We had a problem updating the information...');
  }
}

async function markLessonAsComplete(lessonId) {
  try {
    return commandsController.markLessonAsComplete(lessonId);
  } catch (error) {
    console.error(error);
    throw new Error('[Service]: Oops!, We had a problem updating the information...');
  }
}

async function getClasses(childId) {
  try {
    return await queriesController.fetchClasses({ childId });
  } catch (error) {
    throw new Error('[Service]: Oops!, we were unable to obtain the classes...');
  }
}

async function setClassToNew({ childId, name }) {
  try {
    return await commandsController.createClass({ childId, name });
  } catch (error) {
    throw new Error('[Service]: Oops!, we were unable to creating the class new...');
  }
}

async function deleteClass(classId) {
  try {
    return await commandsController.deleteClass(classId);
  } catch (error) {
    throw new Error('[Service]: Oops!, we were unable to deleting the classes...');
  }
}

async function updateCheckClasses(classesList) {
  try {
    return await commandsController.updateClasses(classesList);
  } catch (error) {
    throw new Error('[Service]: Oops!, we were unable to updating the classes...');
  }
}

async function getSurveys() {
  try {
    return await queriesController.fetchSurveys();
  } catch (error) {
    throw new Error('[Service]: Oops!, Unable to obtain the surveys.');
  }
}

export {
  getModules,
  getModuleSkills,
  setModulesToActivate,
  getSkillLessonsById,
  getLessonDetail,
  setInfoIsHelpfull,
  markVideoisViewed,
  markLessonAsComplete,
  getClasses,
  setClassToNew,
  deleteClass,
  updateCheckClasses,
  getSurveys,
};
